
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-course-license",
      function () {
        return require("private-next-pages/free-course-license.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-course-license"])
      });
    }
  